import firebase from 'firebase/app';
import axios from 'axios';
// import moment from 'moment';

//function

import { reduceTokens } from '../ReduceTokens/ReduceTokens';
import { SaveIntVal } from '../SaveIntVal/SaveIntVal';
import { saveSearch } from '../SaveSearch/SaveSearch';


var arr = [];

export const getShortestModel = (
    profile, 
    fbProfile, 
    vProp, 
    intVal, 
    auth, 
    setContentGen, 
    setGenerating, 
    tokens, 
    docId, 
    url, 
    sendArr, 
    foundInts,
    interestValues,
    setBtnClicked,
    setShowTooltip,
    callToAction,
    setEditing
    ) =>{

    setGenerating(true)
    searchData(intVal, interestValues);
    setBtnClicked(false)
    setEditing(false)
    // setShowTooltip(true)

    if(arr.length > 0){
        if(arr[0].classified === 'Hobby'){
            // console.log('hobby withoutAxios')
            shortestModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction)
        } 
        // else if(arr[0].classified === 'Work'){
        //     console.log('work withoutAxios')
        //     workIntro(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip)
        // } 
        else{
            // console.log('othered withoutAxios')
            shortestModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction)
        }
    }else{
        // console.log('axios');
        const message= { Input: intVal }
        //first classify interest
        axios
        .post('https://boundapiv2.herokuapp.com/getIntClassified', message)
        .then((response) => {
            let classified = response.data
            SaveIntVal(intVal, classified);

            if(classified === 'Hobby'){
                shortestModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction)
            } 
            // else if(classified === 'Work'){
            //     workIntro(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip)
            // } 
            else{
                shortestModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction)
            }
        })
    }
}

const shortestModel = (profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded) =>{
    
    let cta = callToAction?.length > 0 ? callToAction?.[0]?.CTA : 'Would you be open to a 20 min call to explore further?'
    const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJib2R5Ijoic3R1ZmYiLCJpYXQiOjE2MjMxMDUyODR9.8EPq1VG9sw6Dafw9LclznDycHbdJC8wVO3Sqfi_jUMo'
    
    var splitName = profile?.ProspectName?.split(' ')
    var name = profile.first_name ? profile.first_name : splitName?.[0]
    // var input = `${vProp.Pain}\nInterest: ${intVal}.\nValue: ${vProp.ValueProp}`

    // Pain only
    var input = `${vProp.Pain}\nInterest: ${intVal}.`

    const message= { Input: input }
    //first classify interest
    axios 
    .post('https://boundapiv2.herokuapp.com/shortModel', message, { headers: {"Authorization" : `jwt ${token}`} })
    .then((response) => {
        // console.log(response.data)
        let str = response.data
        // console.log(str)
        str = str.substring(str.indexOf(":") + 1)
        // let replaceContent = response.data.replace("Output:", "")
        let replaceContent= str
        let removePer = replaceContent.substr(0, replaceContent.lastIndexOf(".") + 1)
        let personalContent = removePer.trim();

        // console.log(response.data.length)

        // let personalContent = replaceContent.replace(/\n/g, "")
        let type = 'ShortestModel'

        if(response.data.length > 50){
            reduceTokens(auth, tokens)
            let output = `Hey ${name},\n\n${personalContent}\n\n${cta}`
            setContentGen(output)
            // setShowTooltip(false)
            
            if(onboarded?.length > 0 ? onboarded[0].onboarded === 'no' : false){
                console.log('done')
                generatedOutreachAddOnBoard(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts)
            } else{
                generatedOutreachAdd(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts)
            }    

        } else {
            axios.post('https://boundapiv2.herokuapp.com/shortModel', message)
            .then((response) =>{
                console.log(response.data)

                let str = response.data
                // console.log(str)
                str = str.substring(str.indexOf(":") + 1)
                // let replaceContent = response.data.replace("Output:", "")
                let replaceContent= str
                let removePer = replaceContent.substr(0, replaceContent.lastIndexOf(".") + 1)
                let personalContent = removePer.trim();
                let type = 'ShortestModel'

                if(response.data.length > 150){
                    reduceTokens(auth, tokens)
                    let output = `Hey ${name},\n\n${personalContent}\n\n${cta}`
                    setContentGen(output)

                    if(onboarded?.length > 0 ? onboarded[0].onboarded === 'no' : false){
                        console.log('done')
                        // setGenerating(false)
                        generatedOutreachAddOnBoard(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts)
                    } else{
                        generatedOutreachAdd(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts)
                    }   

                } else {
                    let output = `Oops, sorry I went a little blank here. Happens to the best of us :)\n\nDon't worry no token was charged. Just press 'g' or hit the generate button and I'll be good to go again!`
                    setContentGen(output)

                    if(onboarded?.length > 0 ? onboarded[0].onboarded === 'no' : false){
                        console.log('done')
                        generatedOutreachAddOnBoard(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts)
                    } else{
                        generatedOutreachAdd(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts)
                    }   
                }
            })
        }

    })
}

// const workIntro = (profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts) =>{
    
//     // let cta = 'Would you be open to a 20 min call to explore further?'

//     var name = profile.first_name
//     var input = `${vProp.Pain}\nInterest: ${intVal}.\nValue: ${vProp.ValueProp}`
//     const message= { Input: input }
//     //first classify interest
//     axios
//     .post('https://boundserver.herokuapp.com/workIntrov2', message)
//     .then((response) => {
//         console.log(response.data)
//         let replaceContent = response.data.replace("Output:", "")
//         let personalContent = replaceContent.trimStart();
//         let type = 'ShortIntro'
//         reduceTokens(auth, tokens)

//         let output = `Hey ${name},\n\n${personalContent}`
//         setContentGen(output)

//         generatedOutreachAdd(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts)

//     })
// }

//pull that information back into the firebase prospect message generated section

const generatedOutreachAdd = async(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts) =>{

    var messagesRef = firebase
    .firestore()
    .collection('organizations')
    .doc(fbProfile.company)
    .collection('prospects')
    .doc(docId)

    messagesRef.update({
        ContentCreated: firebase.firestore.FieldValue.arrayUnion({
            ProspectName: profile?.full_name ? profile?.full_name : profile.ProspectName,
            ProspectContent: output,
            ProspectValuePropUsed: vProp,
            ProspectInterestUsed: intVal,
            ProspectMessageType: type,
            CreatedAt: new Date(),
        })
    }).then(() =>{
        saveSearch(fbProfile, auth, profile, url, sendArr, output, foundInts, docId)
        setGenerating(false)
    })
}

const searchData = (e, projects) => {
    arr = projects.filter(dataContainsTerm(e))
  };

const dataContainsTerm = (term) => {
    return function (element) {
        let word = term?.toString().toLowerCase();
        let data = element;
        if (data.intVal.toString().toLowerCase() === word &&
            startsWith(data.intVal.toString().toLowerCase(), word)) {
                return true;
        }

        return false;
    };
};

function startsWith(str, word) {
    return str.lastIndexOf(word, 0) === 0;
}

const generatedOutreachAddOnBoard = async(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts) =>{

    var messagesRef = firebase
    .firestore()
    .collection('organizations')
    .doc(fbProfile.company)
    .collection('prospects')
    .doc('onboarding')

    messagesRef.set({
            ProspectContent: output,
            ProspectValuePropUsed: vProp,
            ProspectInterestUsed: intVal,
            ProspectMessageType: type,
            createdAt: new Date(),
    }).then(() =>{
        // saveSearch(fbProfile, auth, profile, url, sendArr, output, foundInts, docId)
        setGenerating(false)
    })
}
